goog.provide("shadow.js.shim.module$src$svg$objects$eye_svg");
goog.provide("module$shadow_js_shim_module$src$svg$objects$eye_svg");
shadow.js.shim.module$src$svg$objects$eye_svg = shadow.js.nativeProvides["src/svg/objects/eye.svg"] = shadow$bridge("src/svg/objects/eye.svg");
module$shadow_js_shim_module$src$svg$objects$eye_svg.default = shadow.js.shim.module$src$svg$objects$eye_svg;
